import { Section } from "@/components/ui/Section";
import { Reveal } from "@/components/common/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ as FAQ_ITEMS } from "@/utils/constants";

export const FAQ = () => (
  <Section id="faq" testId="faq-section" bg="ink" containerClassName="max-w-3xl">
    <Reveal>
      <p className="text-weld-glow font-semibold tracking-[0.25em] uppercase text-sm mb-3">Questions</p>
      <h2 className="font-display text-5xl md:text-6xl text-white">Frequently Asked</h2>
    </Reveal>

    <Reveal delay={0.1}>
      <Accordion type="single" collapsible className="mt-10 w-full">
        {FAQ_ITEMS.map((item, i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-white/10">
            <AccordionTrigger className="text-left text-white hover:text-weld-glow text-lg font-semibold hover:no-underline">
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-white/60 text-base leading-relaxed">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </Section>
);
